import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

import SelectArrowsIcon from '../../../../icons/SelectArrows';

export default ({
  id,
  label,
  options,
  selectedValue,
  value,
  onChange,
  required
}) => (
  <div
    className={classnames(styles.container, {
      [styles.blankValue]: !(value || selectedValue)
    })}
  >
    <label htmlFor={id}>
      {label}
      {required && <span className={styles.required}>(required)</span>}
    </label>
    <div>
      <select
        id={id}
        name={id}
        value={value || selectedValue}
        onChange={onChange}
      >
        {options.map(({ text, value: optionValue }, index) => (
          <option key={index} value={optionValue}>
            {text}
          </option>
        ))}
      </select>
      <div className={styles.arrowContainer}>
        <SelectArrowsIcon size={16} />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/drop-down/index.js